import { useEffect, useState, useContext } from "react";
import Button from "../../components/Buttons/Button";
import deviceService from "../../services/device/deviceService";
import DeviceInfo from "./DeviceInfo/DeviceInfo";
import { getSystemStatusFromFrame } from "../../services/scp/scpUtils";
import bleDeviceConnectionStatus from "../../consts/bleDeviceConnectionStatus";
import LedSettings from "./LedSettings/LedSettings";
import FindMyDevice from "./FindMyDevice/FindMyDevice";
import { useSelector } from "react-redux";
import { getDeviceConnectionStatusById, getDeviceInfoById } from "../../state/ducks/ble/bleService";
import { ModalContext } from "../../contexts/ModalContext"
import FwuUpdateModal from "../Modals/FwuUpdate/FwuUpdateModal";
import BLE_UUID_TYPES from "../../consts/bleUuidTypes";
import { useDeviceConnectionStatus } from "../../hooks/useDeviceConnectionStatus";

const Device = ({ id, name, onDeviceUnselected }) => {

    useDeviceConnectionStatus(id);

    const connectionStatus = useSelector(getDeviceConnectionStatusById(id));
    const [holderConnected, setHolderConnected] = useState(true);
    const deviceInfo = useSelector(getDeviceInfoById(id));

    const onDeviceDisconnected = async () => {
        await deviceService.disconnect(id);
        window.location.reload();
    }

    useEffect(() => {
        if (connectionStatus === bleDeviceConnectionStatus.DISCONNECTED) {
            onDeviceDisconnected();
        }
    }, [connectionStatus]);

    useEffect(() => {
        deviceService.subscribeOnCharacteristic(id, BLE_UUID_TYPES.SYSTEM_STATUS, onSystemStatusHandler);

        return () => {
            deviceService.unsubscribeOnCharacteristic(id, BLE_UUID_TYPES.SYSTEM_STATUS, onSystemStatusHandler)
        }
    }, []);

    const onSystemStatusHandler = (e) => {
        const frame = e?.data?.data;
        const systemStatus = getSystemStatusFromFrame(frame);
        setHolderConnected(systemStatus?.holderConnection === 0);
    }

    const unselectDevice = () => {
        onDeviceUnselected(id);
    };

    const { openModal } = useContext(ModalContext);

    const handleClick = () => {
        openModal(<FwuUpdateModal id={id}/>);
    }

    return (
        <div className="p-4 flex flex-col gap-4 w-full h-full justify-between">
            <div className="flex flex-col gap-6 w-full">
                <div className="w-full items-center text-2xl">{deviceInfo?.name ?? name}</div>
                <div>{`Connection status: ${connectionStatus}`}</div>
                <div>{`Holder Connection status: ${holderConnected ? bleDeviceConnectionStatus.CONNECTED : bleDeviceConnectionStatus.DISCONNECTED}`}</div>
                <div className="border-y border-gray-800">
                        {deviceInfo && <DeviceInfo info={deviceInfo} />}
                        </div>
                        <div className="w-full flex gap-2 flex-col">
                            <button onClick={handleClick}>Update Firmware</button>
                            <FindMyDevice id={id} />
                            <LedSettings id={id} />
                        </div>
                        
            </div>
            <Button onClick={unselectDevice}>
                <div className="flex w-full justify-center items-center">
                    Back to devices
                </div>
            </Button>
        </div>
    );
};

export default Device;
